export enum EProgramType {
  BASE = 'base',
  PREFERENTIAL = 'preferential',
  COUNTRY = 'country',
  IT = 'it',
  FAMILY = 'family',
  FAR = 'far',
}
